"use strict";

import Vue from "vue";
import axios from "axios";
import store from "../store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { Message, MessageBox } from "element-ui";
import Cookies from "js-cookie";

NProgress.configure({
  showSpinner: false
});

axios.defaults.baseURL = `${process.env.VUE_APP_SERVER_API}`;
axios.defaults.headers.post["Content-Type"] = `application/json;charset=utf-8`;
axios.defaults.headers["showLoading"] = true;

let config = {
  timeout: 60 * 10 * 1000, // Timeout
  withCredentials: false, // Check cross-site Access-Control
};

const errMsg = "Network request failed. Please check if the network is available";
let requests = 0;

const _axios = axios.create(config);
_axios.interceptors.request.use(config => {
  requests++;
  if (config.headers.showLoading) {
    NProgress.start()
    delete config.headers.showLoading
  }
  if (!config.headers.Authorization) {
    config.headers.Authorization = `${store.state.token}`
  }
  return config;
}, error => {
  requests--;
  if (0 === requests) {
    Message.error(errMsg);
    NProgress.done();
  }
  return Promise.reject(error);
});

// Add a response interceptor
_axios.interceptors.response.use(response => {
  requests--;
  NProgress.done();
  const contentDisposition = response.headers["content-disposition"];
  if (contentDisposition) {
    const fileName = contentDisposition.match(
      /filename=(.*)/
    )[1]
    return {
      data: {
        file: response.data,
        fileName: fileName
      }
    }
  } else return response.data;
},
  error => {
    requests--;
    if (0 === requests) {
      if (error.message === "Request failed with status code 401") {
        MessageBox.alert("Identity has expired, please login again.", "Warning", {
          confirmButtonText: "Confirm",
          showClose: false,
          type: "warning"
        }).then(() => {
          setTimeout(() => {
            Cookies.remove(process.env.VUE_APP_COOKIE_KEY);
            location.href = "/authorise";
          }, 1000)
        }).catch(() => { });
      } else if (error.message === "Request failed with status code 500") {
        Message.error("Internal Server Error. Please contact to IT administrator");
      } else {
        if(!axios.isCancel(error)) {
          Message.error(errMsg);
        }
      }
      NProgress.done();
    }
    return Promise.reject(error);
  }
);

const Plugin = {};
Plugin.install = function (Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
